// bookingReducer.js
import {
  FETCH_BOOKINGS_REQUEST,
  FETCH_BOOKINGS_SUCCESS,
  FETCH_BOOKINGS_FAILURE,
  DELETE_BOOKING_REQUEST,
  DELETE_BOOKING_SUCCESS,
  DELETE_BOOKING_FAILURE,
  ADD_BOOKING_REQUEST,
  ADD_BOOKING_SUCCESS,
  ADD_BOOKING_FAILURE,
  FETCH_BOOKING_REQUEST,
  FETCH_BOOKING_SUCCESS,
  FETCH_BOOKING_FAILURE,
  FETCH_SERVICE_TYPE_REQUEST,
  FETCH_SERVICE_TYPE_SUCCESS,
  FETCH_SERVICE_TYPE_FAILURE,
  FETCH_CUSTOMER_BOOKINGS_REQUEST,
  FETCH_CUSTOMER_BOOKINGS_SUCCESS,
  FETCH_CUSTOMER_BOOKINGS_FAILURE,
  FETCH_TRANSIT_SERVICE_TYPE_REQUEST,
  FETCH_TRANSIT_SERVICE_TYPE_SUCCESS,
  FETCH_TRANSIT_SERVICE_TYPE_FAILURE,
  FETCH_COMPLEMENTARY_BOOKINGS_REQUEST,
  FETCH_COMPLEMENTARY_BOOKINGS_SUCCESS,
  FETCH_COMPLEMENTARY_BOOKINGS_FAILURE,
  UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_REQUEST,
  UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_SUCCESS,
  UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_FAILURE,
  RESET_BOOKING_DETAILS,
  INSERT_INSTANT_BOOKING_REQUEST,
  INSERT_INSTANT_BOOKING_SUCCESS,
  INSERT_INSTANT_BOOKING_FAILURE,
  INSTANT_TOKEN_GENERATOR_REQUEST,
  INSTANT_TOKEN_GENERATOR_SUCCESS,
  INSTANT_TOKEN_GENERATOR_FAILURE,
  FETCH_INSTANT_BOOKINGS_REQUEST,
  FETCH_INSTANT_BOOKINGS_SUCCESS,
  FETCH_INSTANT_BOOKINGS_FAILURE,
  EDIT_BOOKING_FAILURE,
  EDIT_BOOKING_SUCCESS,
  EDIT_BOOKING_REQUEST,
  GET_ALL_BOOKINGS_REQUEST,
  GET_ALL_BOOKINGS_SUCCESS,
  GET_ALL_BOOKINGS_FAILURE
} from "./BookingType";

const initialState = {
  bookings: [],
  bookingsForExport: [],
  customerBookings: [],
  totalCustomerBookings: 0,
  booking: null,
  data: null,
  approval_message: null,
  loading: false,
  deleteLoading: false,
  error: null,
  success: false,
  message: "",
  serviceType: {
    data: [],
    loading: false,
    error: null
  },
  transitServiceType: {
    data: [],
    loading: false,
    error: null
  },
  instantBooking: {
    data: null,
    success: false,
    loading: false,
    error: null
  }
};

const bookingReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BOOKINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_BOOKINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        bookings: action.payload.data || [],
        totalRecords: action.payload.totalRecords || 0,
        message: action.payload.message || ""
      };

    case FETCH_BOOKINGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case FETCH_BOOKING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_BOOKING_SUCCESS:
      return {
        ...state,
        loading: false,
        booking: action.payload
      };
    case FETCH_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    case ADD_BOOKING_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        success: false
      };
    case ADD_BOOKING_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        message: action.payload?.message
      };
    case ADD_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        success: false,
        error: action.payload
      };

    case INSERT_INSTANT_BOOKING_REQUEST:
      return {
        ...state,
        instantBooking: {
          success: false,
          loading: true,
          error: null
        }
      };

    case INSERT_INSTANT_BOOKING_SUCCESS:
      return {
        ...state,
        instantBooking: {
          data: action.payload,
          success: true,
          loading: false,
          error: null
        }
      };
    case INSERT_INSTANT_BOOKING_FAILURE:
      return {
        ...state,
        instantBooking: {
          success: false,
          loading: false,
          error: action.payload
        }
      };

    case EDIT_BOOKING_REQUEST:
      return {
        ...state,
        instantBooking: {
          success: false,
          loading: true,
          error: null
        }
      };

    case EDIT_BOOKING_SUCCESS:
      return {
        ...state,
        instantBooking: {
          data: action.payload?.updatedData,
          success: true,
          loading: false,
          error: null
        }
      };
    case EDIT_BOOKING_FAILURE:
      return {
        ...state,
        instantBooking: {
          success: false,
          loading: false,
          error: action.payload
        }
      };
    case INSTANT_TOKEN_GENERATOR_REQUEST:
      return {
        ...state,
        instantBooking: {
          success: false,
          loading: true,
          error: null
        }
      };

    case INSTANT_TOKEN_GENERATOR_SUCCESS:
      return {
        ...state,
        instantBooking: {
          data: action.payload,
          success: true,
          loading: false,
          error: null
        }
      };
    case INSTANT_TOKEN_GENERATOR_FAILURE:
      return {
        ...state,
        instantBooking: {
          success: false,
          loading: false,
          error: action.payload
        }
      };

    case DELETE_BOOKING_REQUEST:
      return {
        ...state,
        deleteLoading: true,
        loading: false,
        error: null,
        success: false
      };
    case DELETE_BOOKING_SUCCESS:
      return {
        ...state,
        deleteLoading: false,
        success: true,
        laoding: false,
        message: action.payload,
        bookings: state.bookings.filter(
          (booking) => booking.booking_number !== action.payload
        )
      };
    case DELETE_BOOKING_FAILURE:
      return {
        ...state,
        loading: false,
        deleteLoading: false,
        success: false,
        error: action.payload
      };
    case FETCH_SERVICE_TYPE_REQUEST:
      return {
        ...state,
        serviceType: {
          ...state.serviceType,

          loading: true,
          error: null
        }
      };
    case FETCH_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        serviceType: {
          ...state.serviceType,
          data: action.payload,
          loading: false,
          error: null
        }
      };
    case FETCH_SERVICE_TYPE_FAILURE:
      return {
        ...state,
        serviceType: {
          ...state.serviceType,
          data: [],
          loading: false,
          error: action.payload
        }
      };
    case FETCH_TRANSIT_SERVICE_TYPE_REQUEST:
      return {
        ...state,
        transitServiceType: {
          ...state.transitServiceType,

          loading: true,
          error: null
        }
      };
    case FETCH_TRANSIT_SERVICE_TYPE_SUCCESS:
      return {
        ...state,
        transitServiceType: {
          ...state.transitServiceType,
          data: action.payload,
          loading: false,
          error: null
        }
      };
    case FETCH_TRANSIT_SERVICE_TYPE_FAILURE:
      return {
        ...state,
        transitServiceType: {
          ...state.transitServiceType,
          data: [],
          loading: false,
          error: action.payload
        }
      };
    case FETCH_CUSTOMER_BOOKINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case FETCH_CUSTOMER_BOOKINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        bookings: action.payload.data || [],
        totalRecords: action.payload.totalRecords || 0,
        message: action.payload.message || ""
      };
    case FETCH_CUSTOMER_BOOKINGS_FAILURE:
      return {
        ...state,
        loading: false,
        bookings: [],
        error: action.payload
      };
    case RESET_BOOKING_DETAILS:
      return {
        ...state,
        bookings: [],
        bookingsForExport: [],
        customerBookings: [],
        totalCustomerBookings: 0,
        booking: null,
        data: null,
        approval_message: null,
        loading: false,
        deleteLoading: false,
        error: null,
        success: false,
        message: "",
        serviceType: {
          data: [],
          loading: false,
          error: null
        },
        transitServiceType: {
          data: [],
          loading: false,
          error: null
        },
        instantBooking: {
          data: null,
          success: false,
          loading: false,
          error: null
        }
      };

    case FETCH_COMPLEMENTARY_BOOKINGS_REQUEST:
      return {
        ...state,
        loading: true
      };

    case FETCH_COMPLEMENTARY_BOOKINGS_SUCCESS:
      return {
        ...state,
        bookings: action.payload.data,
        totalRecords: action.payload.totalRecords,
        loading: false
      };

    case FETCH_COMPLEMENTARY_BOOKINGS_FAILURE:
      return {
        ...state,
        bookings: [],
        totalRecords: [],
        loading: false,
        error: action.payload
      };

    case FETCH_INSTANT_BOOKINGS_REQUEST:
      return {
        ...state,
        loading: true
      };

    case FETCH_INSTANT_BOOKINGS_SUCCESS:
      return {
        ...state,
        bookings: action.payload.data,
        totalRecords: action.payload.totalRecords,
        loading: false
      };

    case FETCH_INSTANT_BOOKINGS_FAILURE:
      return {
        ...state,
        bookings: [],
        totalRecords: [],
        loading: false,
        error: action.payload
      };
    case UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
        approval_message: null
      };

    case UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_SUCCESS:
      return {
        ...state,

        data: action.payload?.data,
        loading: false,
        error: null,
        approval_message: action.payload?.message
      };

    case UPDATE_BOOKING_DISCOUNT_APPROVAL_STATUS_FAILURE:
      return {
        ...state,
        data: null,
        loading: false,
        error: action.payload
      };

    case GET_ALL_BOOKINGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_ALL_BOOKINGS_SUCCESS:
      return {
        ...state,
        loading: false,
        bookingsForExport: action.payload.data || [],
        totalRecords: action.payload.totalRecords || 0,
        message: action.payload.message || ""
      };

    case GET_ALL_BOOKINGS_FAILURE:
      return {
        ...state,
        loading: false,
        bookingsForExport: [],
        error: action.payload
      };

    default:
      return state;
  }
};

export default bookingReducer;
